module.exports = __webpack_public_path__ + "static/media/hw-given.34c38eb6.svg";